import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPlaylistPlay = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M2 10.6667V9.33333H7.33333V10.6667H2ZM2 8V6.66667H10V8H2ZM2 5.33333V4H10V5.33333H2ZM10.6667 14V8.66667L14.6667 11.3333L10.6667 14Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgPlaylistPlay);
export default ForwardRef;
